/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Display_TopInputs */



/**
* | output |
* | --- |
* | "Top" |
*
* @param {Input_Position_Display_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_display_top = /** @type {((inputs?: Input_Position_Display_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Display_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spitze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Superiore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вершина")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("顶部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Principal")
	return /** @type {LocalizedString} */ ("Top")
});